import React from "react";

export interface IPaginationModel {
  page: number;
  pageSize: number;
}

interface Props {
  getModel: (key: string, defaultPageSize: number) => IPaginationModel;
  setModel: (key: string, model: IPaginationModel) => void;
}

// The no-provider fallback caches per key for the same reason PaginatorProvider
// does: consumers feed the returned object into useFetch, whose effect depends
// on it by reference, so a fresh literal per call would loop forever.
const fallbackModels: Record<string, IPaginationModel> = {};

const PaginatorContext = React.createContext<Props>({
  getModel: (key, defaultPageSize) => {
    const cached = fallbackModels[key];
    if (cached && cached.pageSize === defaultPageSize) return cached;
    const fresh = { page: 0, pageSize: defaultPageSize };
    fallbackModels[key] = fresh;
    return fresh;
  },
  setModel: () => {},
});

export default PaginatorContext;
